<template>
  <div class="add-hemorrhage public-content">
    <div class="breadcrumb">版式</div>
    <div class="third-title"><span>版式样式</span></div>
    <div class="order-detail-basic">
      <el-form :model="formatMsg" label-width="100px" ref="formRef">
        <el-form-item label="版式缩略图:">
          <el-image :src="formatMsg.layoutThumbnail" fit="cover" :preview-src-list="[formatMsg.layoutThumbnail]" style=" height: 200px;border:1px solid #000;">
          </el-image>
        </el-form-item>
        <el-form-item label="前端是否显示:">
          <el-switch disabled v-model="formatMsg.isShow" :active-value="1" :inactive-value="0" active-color="rgba(20, 115, 230, 1)" inactive-color="rgba(140, 140, 140, 1)">
          </el-switch>
        </el-form-item>
        <el-form-item label="已关联模板页:">
          <templateThumbnail v-for="item in formatMsg.templateGroups" :key="item.id" :templateGroup="item" style="width:200px;margin-right: 20px;" />
        </el-form-item>
      </el-form>
    </div>
    <div class="form-btn" style="margin: 20px 0">
      <el-button round type="primary" @click="$router.go(-1)">返回</el-button>
    </div>
  </div>
</template>
<script>
import templateThumbnail from '@/components/templateThumbnail.vue'
import { layoutQueryLayoutById } from '@/api/pms'
export default {
  name: 'add-hemorrhage',
  components: {
    templateThumbnail
  },
  data () {
    return {
      formatMsg: {}
    }
  },
  mounted () {
    sessionStorage.setItem('searchFlag', true)
  },
  created () {
    this.getFormatMsg()
  },
  methods: {
    // 获取版式详细信息
    getFormatMsg () {
      layoutQueryLayoutById(this.$route.query.id).then(res => {
        this.formatMsg = res.data.data
      })
    }
  }
}
</script>
<style scoped lang="less">
@deep: ~">>>";

.add-hemorrhage {
  .spec-mm {
    span {
      margin-right: 10px;
    }

    .el-input {
      width: 110px;
    }

    @{deep} .el-input-group__append {
      padding: 0 15px;
    }
  }

  .link {
    width: 30px;
    height: 30px;
    border: 1px solid #dcdfe6;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    box-sizing: border-box;

    i {
      font-size: 20px;
      color: #999;
    }
  }

  .active-link {
    background: #1473e6;
    border: 1px solid #1473e6;

    i {
      color: #fff;
    }
  }
}
</style>
